import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, TrendUp, MusicNotes } from "@phosphor-icons/react";
import api from "../lib/api";

export default function MusicBrowse() {
  const [trending, setTrending] = useState([]);
  const [items, setItems] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const [t, c] = await Promise.all([
          api.get("/music/trending?limit=10"),
          api.get("/music/catalog?limit=60"),
        ]);
        setTrending(t.data.items);
        setItems(c.data.items);
      } catch { /* ignore */ }
    })();
  }, []);

  return (
    <div className="min-h-[100dvh] bg-ink pb-32" data-testid="music-browse-page">
      <div className="px-5 pt-6 flex items-center gap-3">
        <Link to="/" className="w-10 h-10 rounded-full crystal-glass flex items-center justify-center text-cream"><ArrowLeft size={18} /></Link>
        <div>
          <p className="text-papaya text-[10px] tracking-[0.3em] uppercase font-bold">Sounds</p>
          <h1 className="text-cream text-3xl font-black tracking-tighter">Music library</h1>
        </div>
      </div>

      {trending.length > 0 && (
        <section className="mt-7 px-5">
          <p className="flex items-center gap-1.5 text-cream/60 text-[10px] tracking-[0.3em] uppercase font-bold mb-3">
            <TrendUp size={12} weight="bold" /> Trending
          </p>
          <div className="flex gap-3 overflow-x-auto no-scrollbar -mx-5 px-5 pb-2">
            {trending.map((m) => (
              <div key={m.id} data-testid={`music-trending-${m.id}`} className="flex-shrink-0 w-32 rounded-2xl bg-white/5 border border-white/10 p-3">
                <div className="w-full aspect-square rounded-xl bg-gradient-to-br from-papaya/30 via-jam-green/20 to-jam-gold/20 flex items-center justify-center text-4xl">{m.cover_emoji}</div>
                <p className="mt-2 text-cream font-bold text-xs truncate">{m.title}</p>
                <p className="text-cream/50 text-[10px] truncate">{m.use_count} videos</p>
              </div>
            ))}
          </div>
        </section>
      )}

      <section className="mt-6 px-5">
        <p className="text-cream/60 text-[10px] tracking-[0.3em] uppercase font-bold mb-3">All sounds</p>
        <div className="space-y-1.5">
          {items.map((m) => (
            <div key={m.id} data-testid={`music-row-${m.id}`} className="flex items-center gap-3 p-2.5 rounded-2xl bg-white/5 border border-white/10">
              <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-papaya/30 via-jam-green/20 to-jam-gold/20 flex items-center justify-center text-lg flex-shrink-0">{m.cover_emoji}</div>
              <div className="flex-1 min-w-0">
                <p className="text-cream font-bold text-sm truncate">{m.title}</p>
                <p className="text-cream/50 text-[11px] truncate">{m.artist} · {m.mood} · {Math.floor(m.duration_sec / 60)}:{String(m.duration_sec % 60).padStart(2, "0")}</p>
              </div>
              <Link to="/create" className="px-3 py-1.5 rounded-full bg-papaya text-ink text-[10px] tracking-[0.2em] uppercase font-black">
                Use
              </Link>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
